const getters = {
    isLoading: (state) => state.isLoading,

    inView: (state) => state.inView,

    showViewer(state) {
        return state.isLoading || Object.values(state.inView).length
    }
};

export default getters;